import { MutationKey } from '@shared/config';
import type { TFormErrorResponse } from '@shared/types';
import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { authApi } from '../../authApi';
import { useAuthSignOut } from '@entities/auth/hooks/useAuthSignOut';

export const useSignOut = (): UseMutationResult<
  void,
  AxiosError<TFormErrorResponse>,
  void
> => {
  const signOut = useAuthSignOut();

  return useMutation({
    mutationKey: [MutationKey.AUTH_LOGOUT],
    mutationFn: () => authApi.signOut(),
    onSuccess: () => {
      signOut();
    },
    onError: () => {
      signOut();
    },
  });
};
